import { useEffect } from 'react';

const CursorEffect = () => {
  useEffect(() => {
    // Add styles to the document head
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      .cursor {
        position: fixed;
        width: 10px;
        height: 10px;
        background-color: rgba(0, 123, 255, 0.8);
        border-radius: 50%;
        pointer-events: none;
        z-index: 9999;
        transform: translate(-50%, -50%);
        transition: width 0.2s, height 0.2s, background-color 0.2s;
      }

      .cursor-follower {
        position: fixed;
        width: 40px;
        height: 40px;
        border: 1px solid rgba(0, 123, 255, 0.5);
        border-radius: 50%;
        pointer-events: none;
        z-index: 9998;
        transform: translate(-50%, -50%);
        transition: 0.1s;
      }

      .cursor.active {
        width: 20px;
        height: 20px;
        background-color: rgba(0, 123, 255, 0.5);
      }

      .cursor-follower.active {
        width: 50px;
        height: 50px;
        border-color: rgba(0, 123, 255, 0.3);
      }

      a, button, .hoverable {
        cursor: none;
      }

      @media (max-width: 768px) {
        .cursor, .cursor-follower {
          display: none;
        }
      }
    `;
    document.head.appendChild(styleElement);

    const cursor = document.querySelector('.cursor');
    const follower = document.querySelector('.cursor-follower');
    
    let posX = 0,
        posY = 0,
        mouseX = 0,
        mouseY = 0;
    
    const mouseMoveHandler = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };
    
    const animateCursor = () => {
      posX += (mouseX - posX) * 0.1;
      posY += (mouseY - posY) * 0.1;
      
      if (cursor) {
        cursor.style.left = `${mouseX}px`;
        cursor.style.top = `${mouseY}px`;
      }
      
      if (follower) {
        follower.style.left = `${posX}px`;
        follower.style.top = `${posY}px`;
      }
      
      requestAnimationFrame(animateCursor);
    };
    
    document.addEventListener('mousemove', mouseMoveHandler);
    requestAnimationFrame(animateCursor);
    
    // Add hover effect for links and buttons
    const hoverElements = document.querySelectorAll('a, button, .hoverable');
    
    hoverElements.forEach(element => {
      element.addEventListener('mouseenter', () => {
        if (cursor) cursor.classList.add('active');
        if (follower) follower.classList.add('active');
      });
      
      element.addEventListener('mouseleave', () => {
        if (cursor) cursor.classList.remove('active');
        if (follower) follower.classList.remove('active');
      });
    });
    
    // Cleanup function
    return () => {
      document.removeEventListener('mousemove', mouseMoveHandler);
      
      hoverElements.forEach(element => {
        element.removeEventListener('mouseenter', () => {});
        element.removeEventListener('mouseleave', () => {});
      });
      
      // Remove the style element when component unmounts
      if (styleElement.parentNode) {
        styleElement.parentNode.removeChild(styleElement);
      }
    };
  }, []);
  
  return null; // This component doesn't render anything
};

export default CursorEffect;